<template>
  <div class="doc-view">
    <table style="width:100%;">
      <tr>
        <td style="width:400px;vertical-align:top;">
          <div style="margin-top:40px;font-size:20px;font-weight:bold;">
            Cystron Technology Limited
          </div>
          <div style="margin-top:6px;">
            10/F Kras Asia Industrial Building 79 Hung To Road, Kwun Tong, Kowloon, Hong Kong<br/>
            <!-- 
            Tel:&nbsp;852-35952155&nbsp;&nbsp;Fax:&nbsp;852-35952165<br/>
            -->
            http://www.cystrontech.com&nbsp;&nbsp;<br/>
            Email:&nbsp;enquiry@cystrontech.com
          </div>
        </td>
        <td style="width:180px">&nbsp;</td>
        <td>
          <div style="text-align:center;">
            <img alt="cystron" src="~@/assets/logo.png" style="width:149px;height:59px;" />
          </div>
          <div style="font-size:20px;font-weight:bold;text-align:center;">
            Packing List
          </div>
          <table style="margin-top:10px;width:100%;border-top:1px solid #000;border-left:1px solid #000;">
            <tr>
              <td style="border-right:1px solid #000;border-bottom:1px solid #000;">Date</td>
              <td style="border-right:1px solid #000;border-bottom:1px solid #000;">Number</td>
            </tr>
            <tr>
              <td style="border-right:1px solid #000;border-bottom:1px solid #000;">{{ doc.doc_date | engDate }}</td>
              <td style="border-right:1px solid #000;border-bottom:1px solid #000;">PKCY{{ doc.id }}</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <table style="width:100%;margin-top:20px;margin-bottom:20px;">
      <tr>
        <td style="width:385px;border:1px solid #000;font-weight:bold;padding:4px;background-color:#ccc;">Bill To:</td>
        <td rowspan="2" style="width:10px;"></td>
        <td style="border:1px solid #000;font-weight:bold;padding:4px;background-color:#ccc;">Ship To:</td>
      </tr>
      <tr>
        <td style="vertical-align:top;padding:4px;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000;font-size:14px;">
          <strong>{{ doc.company_name }}</strong><br/>
          <span v-html="doc.company_address_br"></span><br/><br/>
          Tel:&nbsp;{{ doc.contact_phone }}&nbsp;&nbsp;<span v-if="doc.contact_fax">Fax:</span>&nbsp;{{ doc.contact_fax }}<br/>
          Attn:&nbsp;{{ doc.contact_name }}<br/>
        </td>
        <td style="vertical-align:top;padding:4px;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000;font-size:14px;">
          <div v-if="doc.shipping_company_name"><strong>{{ doc.shipping_company_name }}</strong></div>
          <span v-html="doc.shipping_address_br"></span>
        </td>
      </tr>
    </table>
    <table class="detail-table" style="border-top:1px solid #000;margin-top:10px;">
      <tr>
        <th>Carton No.</th>
        <th style="text-align:left;">Part Number</th>
        <th style="text-align:left;">Brand</th>
        <th style="width:50px;">Qty(PCS)</th>
        <th style="width:140px;">Size(cm)</th>
        <th style="width:90px;">Weight(kg)</th>
        <th style="width:90px;">C/O</th>
      </tr>
      <template  v-for="(item, index) in productList">
        <tr :key="item.id + '1'">
          <td style="border-bottom:0;">{{ item.order_no }}</td>
          <td style="text-align:left;">{{ item.part_no }}</td>
          <td style="text-align:left;">{{ item.brand }}</td>
          <td style="text-align:right;">{{ item.qty | 1000 }}</td>
          <td style="text-align:left;">{{ item.size_1 }}*{{ item.size_2 }}*{{ item.size_3 }}</td>
          <td style="text-align:left;">{{ item.weight }}</td>
          <td style="text-align:left;">{{ item.c_o }}</td>
        </tr>
        <tr :key="item.id + '2'">
          <td>&nbsp;</td>
          <td colspan="6" style="text-align:left;font-size:13px;" v-html="item.remark_br"></td>
        </tr>
      </template>
      <tr>
        <td colspan="3" style="text-align:right;padding-right:4px;font-size:16px;font-weight:bold;">Total</td>
        <td colspan="4" style="text-align:left;">
          <table style="width:100%;">
            <tr>
              <td style="font-size:16px;font-weight:bold;border:0;border-right:1px solid #000;">{{ productList.length }} Carton(s)</td>
              <td style="font-size:16px;font-weight:bold;border:0;border-right:1px solid #000;">Qty:{{ totalQty }}pcs</td>
              <td style="font-size:16px;font-weight:bold;border:0;">Weight:{{ totalWeight }}kg</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <div style="margin-top:10px;font-weight:bold;" v-if="doc.doc_no">Document Number:&nbsp;{{ doc.doc_no }}</div>
    <div style="margin-top:10px;font-weight:bold;" v-if="doc.remarks" v-html="'Remarks:&nbsp;' + doc.remarks_br"></div>
    <table style="width:100%;margin-top:40px;">
      <tr>
        <td style="width:500px;vertical-align: top;">
          <br/>
          Confirmed by<br/><br/><br/><br/>
          __________________________<br/>
          Authorized Signature with Company Chop<br/><br/>
        </td>
        <td style="vertical-align: top;">
          <template v-if="doc.is_hide_cystron === '0'">
          For and on behalf of<br/>
          Cystron Technology Limted
          </template>
          <br/><br/><br/><br/>
          _________________________<br/>
          Signature and chop<br/>
          {{ doc.sales_name }}<br/>
          <el-button type="info" class="no-print" style="position:relative;left:10px;top:-70px;" @click="gz('1')" v-if="doc.gz_type === '0'">盖章中</el-button>
          <el-button type="info" class="no-print" style="position:relative;left:10px;top:-70px;" @click="gz('2')" v-if="doc.gz_type === '0'">盖章英</el-button><br/>
          <img alt="cystron" src="//erp.cystrontech.com/oss/1567090153228.png" style="position:relative;left:40px;top:-130px;width:100px;height:100px;" v-if="doc.gz_type === '1'" @click="gz('0')" />
          <img alt="cystron" src="//erp.cystrontech.com/oss/1567090149325.png" style="position:relative;left:40px;top:-130px;width:100px;height:100px;" v-if="doc.gz_type === '2'" @click="gz('0')" />
        </td>
      </tr>
    </table>
    <div class="no-print" :style="{ padding: '40px', textAlign: 'center', marginTop: doc.gz_type === '0' ? 0 : '-95px' }">
      <el-button @click="print">Print</el-button>
    </div>
  </div>
</template>
<script>
import NP from 'number-precision'
export default {
  data () {
    return {
      doc: {},
      productList: []
    }
  },
  computed: {
    totalQty () {
      let t = 0
      for (let i = 0; i < this.productList.length; i++) {
        t += parseInt(this.productList[i].qty)
      }
      return t
    },
    totalWeight () {
      let t = 0
      for (let i = 0; i < this.productList.length; i++) {
        t = NP.plus(t, parseFloat(this.productList[i].weight))
      }
      return t
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.$http.get('/dbapi/packing_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.doc = data.list[0]
          if (this.doc.sales_name) {
            this.doc.sales_name = this.doc.sales_name.split(' ')[0]
          }
        } else {
          this.$message({
            type: 'error',
            message: data.message
          })
        }
      })
      this.$http.get('/dbapi/packing_details?id=' + this.$route.params.id).then(data => {
        this.productList = data.list
      })
    },
    print () {
      window.print()
    },
    gz (type) {
      this.doc.gz_type = type
      this.$http.post('/dbapi/packing_list_gz_type', { id: this.$route.params.id, gz_type: type })
    }
  }
}
</script>

<style lang="scss">
.doc-view {
  font-family: "Times New Roman";
  padding: 10px;
  font-size: 14px;
  width: 780px;
  margin: 0 auto;
  background-color: #fff;
  -webkit-print-color-adjust: exact;
  table {
    border-spacing: 0;
  }
  .detail-table {
    border-spacing: 0;
    width: 100%;
    border-left: 1px solid #000;
    th {
      padding: 4px;
      text-align: center;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      background-color: #ccc;
    }
    td {
      font-size: 14px;
      padding: 4px;
      text-align: center;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
    }
  }
}
</style>
